<template>
  <div class="core-dashboard-card">
    <div class="core-dashboard-header">
      <span class="core-dashboard-title">{{ title }}</span>
      <span class="core-dashboard-subtitle" v-if="subtitle">{{ subtitle }}</span>
    </div>
    <div class="core-dashboard-grid" :class="{ 'core-grid-wide': isWide }">
      <div v-for="(item, idx) in parsedMetrics" :key="idx" class="core-dashboard-item">
        <div class="core-item-name">{{ item.name }}</div>
        <div class="core-item-value">
          <span class="core-value-num">{{ item.value }}</span>
          <span class="core-value-unit" v-if="item.unit">{{ item.unit }}</span>
        </div>
        <div class="core-item-row">
          <span class="core-item-target" :class="getTargetClass(item)">
            {{ getTargetText(item) }}
          </span>
          <span class="core-item-compare" :class="getCompareClass(item)">
            同比{{ item.compare }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreDashboard',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    metrics: { type: [Array, String], default: () => [] }
  },
  data() {
    return {
      isWide: false
    }
  },
  computed: {
    parsedMetrics() {
      if (Array.isArray(this.metrics)) return this.metrics
      if (typeof this.metrics === 'string') {
        try {
          const parsed = JSON.parse(this.metrics)
          if (Array.isArray(parsed)) return parsed
        } catch (e) { /* ignore */ }
      }
      return []
    }
  },
  mounted() {
    this.checkWidth()
    window.addEventListener('resize', this.checkWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkWidth)
  },
  methods: {
    checkWidth() {
      const el = this.$el
      if (el) {
        this.isWide = el.offsetWidth >= 500
      }
    },
    getTargetText(item) {
      if (!item.target && item.target !== 0) return ''
      const numTarget = Number(item.target)
      if (numTarget === 0) return '基本持平'
      if (numTarget > 0) return `目标完成${numTarget}%`
      return `目标差${numTarget}%`
    },
    getTargetClass(item) {
      if (!item.target && item.target !== 0) return ''
      const numTarget = Number(item.target)
      if (numTarget > 0) return 'core-target-positive'
      if (numTarget < 0) return 'core-target-negative'
      return 'core-target-neutral'
    },
    getCompareClass(item) {
      const compare = item.compare
      if (!compare) return ''
      const numCompare = Number(String(compare).replace(/%|pct/g, ''))
      if (isNaN(numCompare)) return ''
      if (numCompare > 0) return 'core-compare-positive'
      if (numCompare < 0) return 'core-compare-negative'
      return 'core-compare-neutral'
    }
  }
}
</script>

<style lang="scss" scoped>
.core-dashboard-card {
  padding: 16px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.core-dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.core-dashboard-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.core-dashboard-subtitle {
  font-size: 12px;
  color: #94a3b8;
}

.core-dashboard-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.core-dashboard-grid.core-grid-wide {
  grid-template-columns: repeat(3, 1fr);
}

.core-dashboard-item {
  padding: 14px 16px;
  background: #fafbfc;
  border: 1px solid #f0f2f5;
  border-radius: 10px;
  transition: all 0.2s ease;

  &:hover {
    background: #f5f7fa;
    border-color: #e0e4e8;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  }
}

.core-item-name {
  font-size: 12px;
  color: #64748b;
  margin-bottom: 8px;
  font-weight: 500;
}

.core-item-value {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 10px;
}

.core-value-num {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}

.core-value-unit {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.core-item-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.core-item-target {
  font-size: 12px;
  font-weight: 500;
}

.core-item-compare {
  font-size: 12px;
  font-weight: 500;
}

.core-target-positive {
  color: #22c55e;
}

.core-target-negative {
  color: #ef4444;
}

.core-target-neutral {
  color: #64748b;
}

.core-compare-positive {
  color: #22c55e;
}

.core-compare-negative {
  color: #ef4444;
}

.core-compare-neutral {
  color: #64748b;
}
</style>
